import { Help } from '@insurancemenu/imenu-components-lib/dist/icons';
import { styled } from 'styled-components';

export const SupportMessageStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.4rem;

  & a {
    margin: 0 0.5rem;
  }
`;

export const IconStyled = styled(Help)`
  flex-shrink: 0;
`;
